import type { Model } from '@patsnap/tahiti-core';
import type { ShareState } from '../types';

export const ShareModel = Symbol.for('ShareModel');

export interface ShareModel extends Model<ShareState> {}
